import { IonModal, IonContent, IonAlert } from "@ionic/react"
import { useState } from "react";
import { tokenApi } from "../../../api";
import style from "../../../style/Account.module.css";
import { localSet } from "../../../utils/localStorage";
import { validateCreds } from "../../../utils/Webauthn";
import PinCode from "../../../components/PinCode";
import { setShowLoading, showToastMessage } from "../../../components/GlobalLoading";
import { useStore } from "../../../store";
import SVGIcon from "components/SvgComponent";

interface Props {
    getdatas?: any;
    addCommas?: any
}

const DepostiModal: React.FC<Props> = ({
    getdatas,
    addCommas,
}) => {
    const { isDepositModalOpen,changeModalState } = useStore();
    const [pay, setPay] = useState(0)
    const changePay = (e: any) => {
        const one = e.target
        if (one.dataset.index !== undefined) {
            one.dataset.index === 0 ? setPayMent('Apply Pay') : setPayMent('Credit Card')
            setPay(Number(one.dataset.index))
        }
    }
    const [amount, setAmount] = useState<any>('')
    const [payment, setPayMent] = useState('Apply Pay')
    const [cardNum, setCartNum] = useState<any>('')
    const subDeposit = async () => {
        setShowLoading(true)
        await tokenApi('/deposit', {
            money: Number(amount)
        }).then((res) => {
            if (res.code !== 200) {
                showToastMessage(res.detail)
            }
        })
        await getdatas()
        setAmount('')
        setPayMent('Apply Pay')
        setCartNum('')
        localSet('amount', amount)
        setShowLoading(false)
        setOpenAuth0Modal(false)
        changeModalState('isDepositModalOpen', false)
    }

    const [openAuth0Modal, setOpenAuth0Modal] = useState(false)

    // face id failed alert
    const [openFaceIDFailedAlert, setOpenFaceIDFailedAlert] = useState(false)
    const [biometricFailedMessage, setBiometricFailedMessage] = useState('')

    const handleDeposit = async () => {
        if (amount === '') {
            showToastMessage('Please check your input.')
            return
        }
        ;
        if (payment === '') {
            showToastMessage('Please enter payment amount.')
            return
        }
        if (cardNum === '') {
            showToastMessage('Please enter your card number.')
            return
        }
        if (navigator.onLine === false) {
            showToastMessage('Please check your network and try later.')
            return
        }
        setShowLoading(true)

        // face id
        /* let faceIdRes: any;
        try {
            faceIdRes = await validateCreds();
        } catch (e) {
            console.log(e);

            setShowLoading(false)
            setOpenAuth0Modal(true)
            return;
        }
        if (!faceIdRes) {
            console.log('faceIdRes', faceIdRes);

            setShowLoading(false)
            setOpenAuth0Modal(true)
            return;
        }
        subDeposit() */

        let faceIdRes: any;
        try {
            faceIdRes = await validateCreds();
        } catch (e) {
            console.log('verify face id error:', e);
            setBiometricFailedMessage('Biometric verification enablement failed, you need to try again later or restart the application, do you want to switch to PIN code?')
            setOpenFaceIDFailedAlert(true)
            setShowLoading(false)
        }
        if (faceIdRes === true) {
            subDeposit()
        } else if (faceIdRes === 'null') {
            setOpenAuth0Modal(true)
            setShowLoading(false)
        } else if (faceIdRes === 'not') {
            // setBiometricFailedMessage('Biometric verification enablement failed, you need to try again later or restart the application, do you want to switch to PIN code?')
            // setOpenFaceIDFailedAlert(true)
            setOpenAuth0Modal(true)
            setShowLoading(false)
        }
    }

    return (
        <>
            < IonModal isOpen={isDepositModalOpen} mode="ios" onDidDismiss={() => {
                changeModalState('isDepositModalOpen', false)
                setAmount('')
                setPayMent('Apply Pay')
                setCartNum('')
                setOpenAuth0Modal(false)
            }}>
                <IonContent>
                    <div className={style.depositModal}>
                        <div className={style.tit} onClick={() => {
                            changeModalState('isDepositModalOpen', false)
                        }}>
                            <span>Deposit</span>
                            <div>
                                <SVGIcon name="CloseSvg" width="14" height="14" viewBox="0 0 14 14"/>
                            </div>
                        </div>
                        <div className={style.formm}>
                            <div className={style.amount}>
                                <span>Amount</span>
                                <input type="number" value={amount}
                                    maxLength={9}
                                    onKeyDown={(e: any) => {
                                        const { key } = e;
                                        const filteredKeys = new Set(["e", "-", "+", "."]);
                                        if (filteredKeys.has(key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        if (e.target.value.length > 9) {
                                            e.preventDefault();
                                            return
                                        }
                                        setAmount(e.target.value.replace(/^0+/, '').replace(/[^\d]/g, ''))
                                    }}
                                />
                                <div>$</div>
                            </div>
                            <div className={style.checkBox} onClick={(e) => changePay(e)}>
                                <div className={style.onePay}>
                                    <div className={style.leftSvg} data-index={0}>
                                        {pay === 0 ?
                                            <svg data-index={0} width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10 5C7.24 5 5 7.24 5 10C5 12.76 7.24 15 10 15C12.76 15 15 12.76 15 10C15 7.24 12.76 5 10 5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
                                                    fill="#9C94FF" />
                                            </svg>
                                            :
                                            <svg data-index={0} width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
                                                    fill="#CCCCCC" />
                                            </svg>
                                        }
                                    </div>
                                    <span data-index={0}>Apply Pay</span>
                                    <svg data-index={0} width="38" height="24" viewBox="0 0 38 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_182_4657)">
                                            <path
                                                d="M34.597 0H3.40308C3.27316 0 3.14301 0 3.01332 0.000747416C2.9037 0.00151748 2.79433 0.00271788 2.68496 0.00566224C2.44642 0.0120266 2.20585 0.0259104 1.9703 0.0676751C1.73099 0.110165 1.5083 0.17947 1.29105 0.288593C1.07747 0.395745 0.881941 0.535897 0.712492 0.703137C0.542969 0.870377 0.400907 1.06296 0.292316 1.27389C0.181683 1.48822 0.111386 1.70798 0.0686154 1.94426C0.0260539 2.1767 0.0118866 2.41399 0.00545845 2.64907C0.00251985 2.75697 0.00125947 2.86487 0.000545477 2.97274C-0.00021213 3.10096 4.04057e-05 3.22909 4.04057e-05 3.35753V20.6427C4.04057e-05 20.7712 -0.00021213 20.8991 0.000545477 21.0275C0.00125947 21.1354 0.00251985 21.2433 0.00545845 21.3512C0.0118866 21.5861 0.0260539 21.8234 0.0686154 22.0557C0.111386 22.2921 0.181683 22.5118 0.292316 22.7261C0.400907 22.9371 0.542969 23.1299 0.712492 23.2969C0.881941 23.4644 1.07747 23.6045 1.29105 23.7114C1.5083 23.8208 1.73099 23.8902 1.9703 23.9326C2.20585 23.9741 2.44642 23.9882 2.68496 23.9946C2.79433 23.9971 2.9037 23.9985 3.01332 23.999C3.14301 24 3.27316 24 3.40308 24H34.597C34.7267 24 34.8568 24 34.9865 23.999C35.0958 23.9985 35.2052 23.9971 35.3151 23.9946C35.5531 23.9882 35.7936 23.9741 36.0298 23.9326C36.2688 23.8902 36.4915 23.8208 36.7088 23.7114C36.9226 23.6045 37.1175 23.4644 37.2873 23.2969C37.4566 23.1299 37.5986 22.9371 37.7075 22.7261C37.8184 22.5118 37.8886 22.2921 37.9312 22.0557C37.9738 21.8234 37.9876 21.5861 37.994 21.3512C37.997 21.2433 37.9985 21.1354 37.999 21.0275C38 20.8991 38 20.7712 38 20.6427V3.35753C38 3.22909 38 3.10096 37.999 2.97274C37.9985 2.86487 37.997 2.75697 37.994 2.64907C37.9876 2.41399 37.9738 2.1767 37.9312 1.94426C37.8886 1.70798 37.8184 1.48822 37.7075 1.27389C37.5986 1.06296 37.4566 0.870377 37.2873 0.703137C37.1175 0.535897 36.9226 0.395745 36.7088 0.288593C36.4915 0.17947 36.2688 0.110165 36.0298 0.0676751C35.7936 0.0259104 35.5531 0.0120266 35.3151 0.00566224C35.2052 0.00271788 35.0958 0.00151748 34.9865 0.000747416C34.8568 0 34.7267 0 34.597 0Z"
                                                fill="#334663" />
                                            <path
                                                d="M34.5971 0.799957L34.9808 0.800682C35.0848 0.801407 35.1888 0.802517 35.2933 0.805325C35.4751 0.810172 35.6878 0.819888 35.8861 0.854949C36.0584 0.88557 36.203 0.932137 36.3417 1.0018C36.4786 1.07045 36.6041 1.16042 36.7136 1.26834C36.8236 1.37699 36.9149 1.50097 36.9854 1.63756C37.0556 1.77334 37.1025 1.91526 37.1334 2.08653C37.1688 2.28 37.1786 2.49041 37.1836 2.6709C37.1864 2.77277 37.1878 2.87465 37.1883 2.97895C37.1893 3.10508 37.1893 3.23114 37.1893 3.35752V20.6427C37.1893 20.7691 37.1893 20.8949 37.1883 21.0238C37.1878 21.1256 37.1864 21.2275 37.1836 21.3295C37.1786 21.5098 37.1688 21.7201 37.133 21.9158C37.1025 22.0847 37.0557 22.2267 36.985 22.3631C36.9147 22.4994 36.8236 22.6232 36.7141 22.7312C36.6039 22.8399 36.4789 22.9296 36.3403 22.9989C36.2026 23.0682 36.0583 23.1147 35.8877 23.145C35.6854 23.1806 35.4638 23.1904 35.2969 23.1948C35.1919 23.1972 35.0874 23.1986 34.9803 23.1991C34.8527 23.2001 34.7247 23.2 34.5971 23.2H3.40322C3.40152 23.2 3.39987 23.2 3.39815 23.2C3.27202 23.2 3.14564 23.2 3.01721 23.1991C2.9125 23.1986 2.80802 23.1972 2.70701 23.1949C2.53629 23.1904 2.31454 23.1806 2.11391 23.1453C1.9418 23.1147 1.79751 23.0682 1.65802 22.998C1.52075 22.9293 1.39579 22.8397 1.28557 22.7308C1.1762 22.6231 1.08531 22.4996 1.01504 22.3632C0.944695 22.2268 0.897632 22.0845 0.866687 21.9135C0.830917 21.7182 0.821091 21.5087 0.81618 21.3297C0.813377 21.2272 0.812206 21.1248 0.81154 21.0229L0.811035 20.7221L0.811058 20.6427V3.35752L0.811035 3.27812L0.811517 2.978C0.812206 2.87551 0.813377 2.77304 0.81618 2.67065C0.821091 2.49147 0.830917 2.28192 0.866983 2.08492C0.897655 1.91553 0.944695 1.77316 1.01541 1.63616C1.08513 1.50074 1.17618 1.37712 1.28613 1.26868C1.39563 1.1606 1.52101 1.07075 1.65914 1.00144C1.79714 0.932114 1.94171 0.88557 2.11382 0.855017C2.31213 0.819866 2.52497 0.810172 2.70726 0.805302C2.81116 0.802517 2.91507 0.801407 3.0182 0.800705L3.40322 0.799957H34.5971Z"
                                                fill="#101A25" />
                                            <path
                                                d="M10.3741 8.0722C10.6995 7.67071 10.9203 7.13163 10.8621 6.58075C10.3858 6.60411 9.80455 6.89075 9.46805 7.29255C9.16591 7.63664 8.89849 8.19829 8.9682 8.72607C9.50287 8.77183 10.037 8.46242 10.3741 8.0722Z"
                                                fill="white" />
                                            <path
                                                d="M10.8558 8.82914C10.0794 8.78351 9.41917 9.26389 9.04837 9.26389C8.67737 9.26389 8.10956 8.85213 7.49542 8.86323C6.69608 8.87481 5.95439 9.32068 5.54876 10.0298C4.71445 11.4485 5.32859 13.5528 6.13991 14.7082C6.53391 15.2798 7.00874 15.9092 7.63441 15.8866C8.22556 15.8637 8.45726 15.509 9.17583 15.509C9.89387 15.509 10.1026 15.8866 10.7284 15.8752C11.3773 15.8637 11.783 15.3033 12.177 14.7311C12.629 14.0795 12.814 13.4503 12.8256 13.4158C12.814 13.4043 11.5743 12.9351 11.5628 11.5283C11.5511 10.3503 12.5361 9.79001 12.5825 9.75526C12.0262 8.94364 11.1571 8.85213 10.8558 8.82914Z"
                                                fill="white" />
                                            <path
                                                d="M17.6168 7.23493C19.3044 7.23493 20.4796 8.38257 20.4796 10.0534C20.4796 11.7303 19.2802 12.8839 17.5745 12.8839H15.706V15.8154H14.356V7.23492H17.6168V7.23493ZM15.706 11.766H17.255C18.4304 11.766 19.0993 11.1417 19.0993 10.0594C19.0993 8.97726 18.4304 8.35882 17.261 8.35882H15.706V11.766Z"
                                                fill="white" />
                                            <path
                                                d="M20.8325 14.0375C20.8325 12.9433 21.6824 12.2714 23.1893 12.1882L24.9251 12.0871V11.6055C24.9251 10.9098 24.4489 10.4935 23.6534 10.4935C22.8998 10.4935 22.4297 10.8502 22.3153 11.4093H21.0857C21.158 10.2794 22.1344 9.44695 23.7016 9.44695C25.2385 9.44695 26.2209 10.2497 26.2209 11.5044V15.8154H24.9732V14.7867H24.9432C24.5756 15.4824 23.7739 15.9224 22.9422 15.9224C21.7005 15.9224 20.8325 15.1613 20.8325 14.0375ZM24.9251 13.4726V12.9791L23.3639 13.0742C22.5864 13.1277 22.1465 13.4667 22.1465 14.0018C22.1465 14.5488 22.6045 14.9056 23.3037 14.9056C24.2138 14.9056 24.9251 14.2872 24.9251 13.4726Z"
                                                fill="white" />
                                            <path
                                                d="M27.3988 18.1166V17.076C27.4951 17.0997 27.712 17.0997 27.8206 17.0997C28.4233 17.0997 28.7488 16.8501 28.9476 16.2079C28.9476 16.1959 29.0623 15.8273 29.0623 15.8214L26.772 9.55991H28.1822L29.7856 14.65H29.8096L31.413 9.55991H32.7872L30.4123 16.1424C29.8701 17.6588 29.2432 18.1463 27.9292 18.1463C27.8206 18.1463 27.4951 18.1344 27.3988 18.1166Z"
                                                fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_182_4657">
                                                <rect width="38" height="24" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div className={style.onePay}>
                                    <div className={style.leftSvg} data-index={1}>
                                        {pay === 1 ?
                                            <svg data-index={1} width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10 5C7.24 5 5 7.24 5 10C5 12.76 7.24 15 10 15C12.76 15 15 12.76 15 10C15 7.24 12.76 5 10 5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
                                                    fill="#9C94FF" />
                                            </svg>
                                            :
                                            <svg data-index={1} width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
                                                    fill="#CCCCCC" />
                                            </svg>
                                        }
                                    </div>
                                    <span data-index={1}>Credit Card</span>
                                </div>
                            </div>
                            <div className={`${style.amount} ${style.inputleft}`}>
                                <span>Card Number</span>
                                <input type="number"
                                    value={cardNum}
                                    onKeyDown={(e) => {
                                        const { key } = e;
                                        const filteredKeys = new Set(["e", "-", "+", "."]);
                                        if (filteredKeys.has(key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => setCartNum(e.target.value.replace(/^0+/, '').replace(/[^\d]/g, ''))} />
                            </div>
                            <div className={style.dateAndCode}>
                                <div className={style.one}>
                                    <span>Expiry Date</span>
                                    <div>
                                        <input type="text" placeholder="MM" />
                                        <span>/</span>
                                        <input type="text" placeholder="YY" />
                                    </div>
                                </div>
                                <div className={style.one}>
                                    <span>Security Code</span>
                                    <div className={style.code}>
                                        <input type="number" />
                                    </div>
                                </div>
                            </div>
                            <div className={style.btn} onClick={handleDeposit}>
                                Deposit {amount !== '' && '$' + addCommas(amount)}
                            </div>
                            <div className={style.bottomDes}>
                                This payment will involve you agree with the <span>terms and conditions.</span>
                            </div>
                        </div>
                    </div>

                </IonContent>
            </IonModal>
            {/* pin code modal  */}
            {openAuth0Modal && <PinCode
                openAuth0Modal={openAuth0Modal}
                setOpenAuth0Modal={setOpenAuth0Modal}
                buyFunc={subDeposit}
            // afterBuyCloseModal={setOpenDepositModal}
            />}

            <IonAlert
                isOpen={openFaceIDFailedAlert}
                onDidDismiss={() => {
                    setOpenFaceIDFailedAlert(false)
                }}
                mode="ios"
                message={biometricFailedMessage}
                buttons={[
                    {
                        text: 'Yes',
                        role: 'yes',
                        handler: async () => {
                            setOpenAuth0Modal(true)
                        },
                    },
                    {
                        text: 'No',
                        role: 'no',
                        handler: async () => {
                        }
                    }
                ]}
            />
        </>
    )
}
export default DepostiModal